import { BehaviorSubject } from 'rxjs';
import { getPageNavigationType, getSessionStorageObject, setSessionStorageObject } from '../services/UtilitiesService';

/*      rxjs      */

const defaultState = {
  ovpMfeConfigs: [],
  ovpMfeConfigsError: false,
  preOrderVehicles: [],
  prePurchaseVehicles: [],
  postPurchaseVehicles: [],
  appraisals: [],
  vehicleCount: 0,
  oneCarOnlyStatus: '',
  ovpVehicleReferenceId: 0,
  showBacklink: true,
  garageActiveState: false,
  garageDataError: false,
  isGarageDataFetched: false,
  ovpData: [],
  ovpDataError: {},
  ovpMfeData: {},
  ovpMfeDataError: {},
  ovpReferenceType: '',
  hasReserved: false,
  isOneYearPurchase: false,
};

let subject: any = null;

export const getAppState = () => {
  // if (getPageNavigationType() === 'reload') {
  // return getSessionStorageObject('frontEndState');
  // }
  return subject.value;
};

export const useAppState = () => {
  if (!subject) {
    subject = new BehaviorSubject(defaultState);
  }
};

export const setAppState = (newState: any) => {
  setSessionStorageObject('frontEndState', newState);
  subject.next(newState);
};
